module.exports = __webpack_public_path__ + "img/us-al.e83684d8.svg";